<template>
    <div>
        <AddCommentModal ref="commentModal" :isVisible="showAddCommentModal"
                         @close="modalCloseHandler()">
        </AddCommentModal>
        <div class="panel ">
            <div class="panel-body">
                <div class="row editor-row">
                    <div class="col-xs-12 editor-col">
                        <div v-if="!loaded && !error" style="height: 45vh;">
                            <p class="text-center"
                               style="position:absolute; top: 45%; width: 100%;">
                            <span class="fa fa-cog fa-spin fa-5x"
                                  style="color: #41a499; font-family: FontAwesome !important;">
                            </span>
                            </p>
                        </div>
                        <quality-editor v-if="error"
                                        height="45vh"
                                        :code="errorCode"
                                        language="javascript"
                                        :minimap="false">
                        </quality-editor>
                        <quality-editor v-if="loaded && !error"
                                        ref="solutionEditor"
                                        height="45vh"
                                        :code="solution.code"
                                        :file-path="solution.filePath"
                                        :minimap="false"
                                        @loaded="registerCommentAction()"
                                        @focused="codeIsSelected=true"
                                        :folding="false"
                                        @addCommentButtonClicked="openCommentWindow()">
                        </quality-editor>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QualityEditor from "../workspace/QualityEditor";
    import {eventBus, services} from "../../main";
    import AddCommentModal from "./AddCommentModal";

    export default {
        name: "NewSolutionEditorComponent",
        components: {AddCommentModal, QualityEditor},
        props: {
            solutionId: {type: String, required: false}
        },
        data() {
            return {
                solutionRequest: services.rankTheCodeService.getSolution(this.solutionId),
                codeCommentsRequest: services.rankTheCodeService.getCodeComments(this.solutionId),
                publicUserProfilesRequestForSolution: {loaded: false, error: null},
                publicUserProfilesRequestForComments: {loaded: false, error: null},
                publicUserIdMap: new Map(),
                showAddCommentModal: false,
                codeIsSelected: false,
                errorCode: "// sorry EntwicklerHeld you see this code because you have not solved this challenge!\n" +
                    "function youHaveNotSolvedThisChallenge() {\n" +
                    "    return true;\n" +
                    "}\n",
                editorLoaded: false,
            }
        },
        mounted() {
            eventBus.$on("rank-the-code-comments-updated", () => {
                this.reloadCodeComments();
            });
        },
        beforeDestroy() {
            eventBus.$off('rank-the-code-comments-updated');
        },
        computed: {
            loaded: function () {
                return this.solutionRequest.loaded;
            },
            error: function () {
                return this.solutionRequest.error;
            },
            solution: function () {
                return this.solutionRequest.apiData;
            },
            publicUserIds: function () {
                let publicUserIds = [];
                if (this.solutionRequest.loaded && !this.solutionRequest.error) {
                    publicUserIds.push(this.solutionRequest.apiData.publicUserId);
                }
                return publicUserIds;
            },
            codeCommentsWithUserData: function () {
                let codeCommentsList = [];
                if (!this.codeCommentsRequest.loaded || !this.publicUserProfilesRequestForComments.loaded) {
                    return codeCommentsList;
                }
                for (let codeComment of this.codeCommentsRequest.apiData) {
                    codeComment.user.userName = this.getUserName(codeComment.user.publicId);
                    codeComment.user.userImage = this.getUserImage(codeComment.user.publicId);
                    for (let commentForCodeComment of codeComment.comments) {
                        commentForCodeComment.userName = this.getUserName(commentForCodeComment.publicUserId);
                        commentForCodeComment.userImage = this.getUserImage(commentForCodeComment.publicUserId);
                    }
                    codeCommentsList.push(codeComment);
                }
                return codeCommentsList;
            },
            editorAndCommentsAreLoaded: function() {
                return this.editorLoaded && this.codeCommentsRequest.loaded && this.publicUserProfilesRequestForComments.loaded;
            }
        },
        methods: {
            registerCommentAction() {
                this.$refs.solutionEditor.initializeCodeCommentAddButtons();
                this.$refs.solutionEditor.editor.addAction({
                    // An unique identifier of the contributed action.
                    id: 'comment-code',

                    // A label of the action that will be presented to the user.
                    label: 'Code kommentieren',

                    // An optional array of keybindings for the action.
                    keybindings:
                        Object.keys(monaco.KeyCode).filter(key => monaco.KeyCode[key]),
                    // A precondition for this action.
                    precondition: null,

                    // A rule to evaluate on top of the precondition in order to dispatch the keybindings.
                    keybindingContext: null,

                    contextMenuGroupId: 'navigation',

                    contextMenuOrder: 1.5,

                    // Method that will be executed when the action is triggered.
                    // @param editor The editor instance is passed in as a convinience
                    run: (editor) => {
                        let selection = editor.getSelection();
                        let range = {
                            startLineNumber: selection.startLineNumber,
                            startColumn: selection.startColumn,
                            endLineNumber: selection.endLineNumber,
                            endColumn: selection.endColumn,
                        };
                        this.$refs.commentModal.setSolutionId(this.solutionId);
                        this.$refs.commentModal.setRange(range);

                        let selectedCode = editor.getModel().getValueInRange(selection);
                        if (selectedCode === "") {
                            selectedCode = editor.getModel().getValueInRange(new monaco.Range(range.startLineNumber, 0, range.endLineNumber + 1, 0));
                        }
                        this.$refs.commentModal.setCode(selectedCode);
                        this.showAddCommentModal = true;
                        return null;
                    }
                });
                this.editorLoaded = true;
            },
            getUserName(publicUserId) {
                if (!this.publicUserIdMap.has(publicUserId)) {
                    return "Anonymer EntwicklerHeld"
                }
                return this.publicUserIdMap.get(publicUserId)["displayName"];
            },
            getUserImage(publicUserId) {
                if (!this.publicUserIdMap.has(publicUserId)) {
                    return "https://s3.amazonaws.com/s3-cuescience/anonym-user.png"
                }
                return this.publicUserIdMap.get(publicUserId)["profilePicture"];
            },
            updatePublicUserIdMap(requestData) {
                requestData.forEach(publicUserData => this.publicUserIdMap.set(publicUserData.publicUserId, {
                    displayName: publicUserData.displayName,
                    profilePicture: publicUserData.profilePicture
                }))
            },
            renderComments: function () {
                this.$refs.solutionEditor.renderComments(this.codeCommentsWithUserData);
                this.$refs.solutionEditor.getCodeCommentAddButtonsForRendering();
            },
            centerEditorFocus: function (comment) {
                this.$refs.solutionEditor.editor.revealLinesInCenterIfOutsideViewport(comment.range.startLineNumber, comment.range.endLineNumber, 0)
            },
            highlightComment(comment) {
                this.$refs.solutionEditor.highlightComment(comment.range);
            },
            modalCloseHandler() {
                this.showAddCommentModal = false;
                this.$emit('addCommentModalClosed');
            },
            resetData() {
                this.$emit('userHasSolvedThisChallenge', false);
                this.codeIsSelected = false;
                this.editorLoaded = false;
                this.publicUserProfilesRequestForSolution = {loaded: false, error: null};
                this.publicUserProfilesRequestForComments = {loaded: false, error: null};
            },
            openCommentWindow() {
                this.$refs.solutionEditor.editor.getAction('comment-code').run();
            },
            reloadCodeComments() {
                this.codeCommentsRequest = services.rankTheCodeService.getCodeComments(this.solutionId)
            },
        },
        watch: {
            "solutionRequest.loaded": function () {
                if (this.solutionRequest.loaded && !this.solutionRequest.error) {
                    let publicUserIds = [this.solutionRequest.apiData.publicUserId];
                    this.publicUserProfilesRequestForSolution = services.userService.getDataForPublicUserIds(publicUserIds);
                    this.$emit('userHasSolvedThisChallenge', true)
                }

            },
            "codeCommentsRequest.loaded": function () {
                if (this.codeCommentsRequest.loaded && !this.codeCommentsRequest.error) {
                    let publicUserIds = [];
                    for (let codeComment of this.codeCommentsRequest.apiData) {
                        publicUserIds.push(codeComment.user.publicId);
                        for (let commentForCodeComment of codeComment.comments) {
                            publicUserIds.push(commentForCodeComment.publicUserId);
                        }
                    }
                    this.publicUserProfilesRequestForComments = services.userService.getDataForPublicUserIds(publicUserIds);
                    this.$emit('userHasSolvedThisChallenge', true)
                }

            },
            "publicUserProfilesRequestForSolution.loaded": function () {
                if (this.publicUserProfilesRequestForSolution.loaded && !this.publicUserProfilesRequestForSolution.error) {
                    this.updatePublicUserIdMap(this.publicUserProfilesRequestForSolution.apiData);
                }
            },
            "publicUserProfilesRequestForComments.loaded": function () {
                if (this.publicUserProfilesRequestForComments.loaded && !this.publicUserProfilesRequestForComments.error) {
                    this.updatePublicUserIdMap(this.publicUserProfilesRequestForComments.apiData);
                }
            },
            "solutionId": function () {
                this.resetData();
                this.solutionRequest = services.rankTheCodeService.getSolution(this.solutionId);
                this.codeCommentsRequest = services.rankTheCodeService.getCodeComments(this.solutionId);
            },
            "editorAndCommentsAreLoaded": function () {
                if (this.editorAndCommentsAreLoaded) {
                    this.renderComments();
                }
            }
        }
    }
</script>

<style scoped>
    .editor-row {
        padding: 10px 0;
    }

    .editor-row .editor-col {
        padding-left: 0;
        padding-right: 0;
    }

    .comment-button {
        opacity: 0.2;
        font-size: 2.5rem;
    }

    .active {
        opacity: 1.0;
    }

    .comment-button.active:hover {
        cursor: pointer;
    }
</style>
